<template>
  <div :style="style">
    <Wp_img_swipe style=""
                  :icon="icon"
                  :title="title"
                  :title-style="title_style"
                  :auto-play="auto_play"
                  :duration="1000"
                  :radius="radius"
                  :list="childList"
                  :height="image_height"
                  :img-gray="imgGray"
                  @clickImage="clickBannerImage"
    >
    </Wp_img_swipe>
    <van-popup
        v-model="showActivityInfo"
        closeable
        round
        position="bottom"
        :style="{ height: '90%' }"
    >
      <JdActivityInfoCard :act-data="currentActivityInfo"></JdActivityInfoCard>
    </van-popup>
  </div>
</template>

<script>

import Wp_img_swipe from '../custom/Wp_img_swipe'
import JdActivityInfoCard from '../card/JdActivityInfoCard'
import union_utils from '../../js/union_utils'
import common from '../../js/common'

export default {
  name: 'Wp_home_banner_model',
  components: { Wp_img_swipe, JdActivityInfoCard },
  props: {
    params: { type: Object },
    list: { type: Array },
    imgGray: { type: Boolean, default: false }
  },
  data () {
    return {
      showActivityInfo: false,
      currentActivityInfo: {},
      image_height: 0,
      radius: 0,
      auto_play: 5000,
      childList: [],
      icon: '',
      title: '',
      title_style: '',
      style: '',
      url: '',
    }
  },
  watch: {
    list: {
      handler (newV, oldV) {
        this.childList = newV
      },
      immediate: true,
      deep: true,
    },
  },
  created () {
    this.initBannerDatas()
  },
  methods: {
    initBannerDatas () {
      if (this.params) {
        if (this.params.icon) {
          this.icon = this.params.icon
        }
        if (this.params.title) {
          this.title = this.params.title
        }
        if (this.params.title_style) {
          this.title_style = this.params.title_style
        }
        if (this.params.radius) {
          this.radius = this.params.radius
        }
        if (this.params.auto_play) {
          this.auto_play = this.params.auto_play
        }
        // if(this.params.list){
        //     this.list = this.params.list;
        // }
        if (this.params.style) {
          this.style = this.params.style
        }
        //url不为空的情况下，从url中读取数据
        if (this.params.url) {
          this.url = this.params.url
          this.loadUrl(this.url)
        }
      }

      // if(this.$common.screenWidth <= 320){
      //     this.image_height = "130px";
      // }else{
      //     this.image_height = "160px";
      // }
      this.image_height = (this.$common.screenWidth / 3) + 'px'
    },
    clickBannerImage (item) {
      // this.$common.homeModelClickTo(item, this.$router);
      if (item.actData) {
        if (this.$common.getPid()) {
          this.currentActivityInfo = item.actData
          if (common.isClient()) {
            this.$union_utils.getActivityUnionLink(this.currentActivityInfo, shortUrl => {
              window.location.href = shortUrl
            })
          } else {
            this.showActivityInfo = true
          }
        } else {
          this.$toast.fail({
            message: '此内容注册用户才可查看'
          })
        }
      } else {
        this.$clickHomeModelTo(item)
      }
    },

    loadUrl (url) {
      if (url) {
        url = this.$union_utils.handleUbb(url)
        this.$union_utils.getUrl(url, res => {
          if (res.code === 200) {
            let _list = res.data
            for (let i in _list) {
              let _data = _list[i]
              let _propInfo = this.getPropInfo(_data)
              if (_propInfo) {
                this.childList.push(_propInfo)
              }
            }
          }
        })
      }
    },
    getPropInfo (data) {
      if (data) {
        let _img = this.$union_utils.getActivityImage(data.imgList, '1080*430')
        if (_img) {
          let _propInfo = {
            component: 'banner_cell',
            props: {
              id: 'C_1620890584077',
              img: _img,
              url: data.urlM,
              urlM: data.urlM,
              title: data.title,
              url_type: -1,
              wx_hide: false,
              actData: data,
            }
          }
          return _propInfo
        }
      }
    },

  }
}
</script>

<style scoped>

</style>